import React from "react";
import logo from "../assets/logo.png";

export default function Logo() {
  return (
    <div>
      <img src={logo} alt="logo" width="100%" />
    </div>
  );
}
